import { ExitToApp as ExitToAppIcon } from '@mui/icons-material';

export default function LogOut(): JSX.Element {
  return <ExitToAppIcon fontSize="inherit" />;
}
